import get from 'lodash/get'
import { IAutocompleteBaseOption, TAutocompleteValue } from '../types'

export const isAutocompleteBaseOption = (
  arg: TAutocompleteValue
): arg is IAutocompleteBaseOption => {
  return typeof get(arg, 'groupIndex') === 'number'
}

export const isAutocompleteAddOption = (
  arg: TAutocompleteValue
): arg is IAutocompleteBaseOption & { id: 'add-option' } => {
  return isAutocompleteBaseOption(arg) && get(arg, 'id') === 'add-option'
}
